{
  "colors": {
    "ink": "#1e293b",
    "inkSoft": "#334155",
    "muted": "#64748b",
    "rule": "#cbd5e1",
    "surface": "#ffffff",
    "surfaceSoft": "#f1f5f9",
    "current": "rgba(56,189,248,0.10)",
    "brand": "#38bdf8",
    "brandSoft": "#a78bfa",
    "brandWash": "rgba(56,189,248,0.1)",
    "mono": "ui-monospace, SFMono-Regular, Menlo, monospace"
  },
  "accents": [
    "#38bdf8",
    "#22d3ee",
    "#6366f1",
    "#a78bfa",
    "#2dd4bf",
    "#f97316",
    "#ee7733",
    "#cc6677",
    "#eab308",
    "#f59e0b",
    "#10b981",
    "#84cc16"
  ]
}
